import React from 'react'
import { LoginPageQuery } from 'front-end/src/pages/auth/login/LoginPage.codegen'
import {
  AdditionalSelfSignUpFieldsEnum,
  AllowedUserFieldsEnum
} from 'shared/accountNameConfig'
import { UserSecurityQuestionsEnum } from 'shared/enums/UserSecurityQuestionsEnum'
import { SecurityQuestionsDataInput } from '../../../graphql/public/PublicSchemaTypes'
import { OrganisationRoleEnum } from 'types/Organisation'

export type LoginContextVerificationDataType = Record<
  AllowedUserFieldsEnum,
  string
> | null

export type UserAdditionalDataInput = Partial<
  Record<AllowedUserFieldsEnum, string> &
    Record<AdditionalSelfSignUpFieldsEnum, string>
>

export type LoginContextUserType =
  | (UserAdditionalDataInput & {
      organisation_role?: OrganisationRoleEnum
      privacy_policy_accepted?: Date
    })
  | null

export type LoginContextType = {
  stepView: React.FC
  additionalFieldsList: AllowedUserFieldsEnum[]
  setStepView: (step: React.FC) => void
  pickUserAdditionalData(): UserAdditionalDataInput
  shouldAskSecurityQuestions: () => boolean
  password: string
  setPassword: (p: string) => void
  additionalData: UserAdditionalDataInput
  setAdditionalData: (data: UserAdditionalDataInput) => void
  organisation: LoginPageQuery['organisation']
  isAccountNameLoginOn: boolean
  userData: LoginContextUserType
  setUserData: (
    userData: Partial<LoginContextUserType>,
    replace?: boolean
  ) => void
  userIdentity: string
  setUserIdentity: (id: string) => void
  selfSignupToken?: string | null
  verificationData: LoginContextVerificationDataType
  setVerificationData: (data: LoginContextVerificationDataType) => void
  isExistingUser: boolean
  setIsExistingUser: (exists: boolean) => void
  usedSecurityQuestions: UserSecurityQuestionsEnum[] | null
  setUsedSecurityQuestions: (sq: UserSecurityQuestionsEnum[] | null) => void
  securityQuestions: SecurityQuestionsDataInput[]
  setSecurityQuestions: (sq: SecurityQuestionsDataInput[]) => void
  userHasEmail: boolean
  setUserHasEmail: (has: boolean) => void
  userNeedToAcceptPrivacyPolicy: boolean
  privacyPolicyEnabled: boolean
  privacyPolicyUrl: string | null
}

export const LoginContext = React.createContext<LoginContextType>(
  null as unknown as LoginContextType
)

export const useLoginContext = () => React.useContext(LoginContext)
